/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { TASKBAR_H } from '../lib/config.js';
import { playPop } from '../lib/sound.js';

export default {
  /**
   * Sta je nu te tekenen?
   *
   * Waar is het tekenscherm open én niet weggeklapt. Dit is de vraag die zestien
   * plekken stelden aan `view === 'studio'`, en de enige van de drie betekenissen die
   * dat veld had waar het echt om ging: ligt het doek vóór je.
   *
   * Voor "staat het doek in de pagina" gebruik je `this.canvasRef.current`. Dat is
   * iets anders: een weggeklapt venster houdt zijn doek, anders is je werk weg.
   */
  tekentNu() { return !!this.state.studioOpen && !this.state.studioMin; },

  /**
   * Ligt de paal in beeld?
   *
   * Op een computer altijd: de paal is het bureaublad en het tekenvenster is een
   * programmaatje dat er half over hangt. Op de telefoon is het nog een of-of, want
   * daar vult het tekenscherm het beeld.
   *
   * Hier hangt de klok van vijftien seconden aan die de paal bijhoudt. Die stond aan
   * `tekentNu()`, van toen tekenen nog een heel scherm was: openen zette hem uit,
   * wegklappen weer aan. Sinds het venster al open staat als je binnenkomt zou hij
   * daarmee een hele sessie stil blijven staan en zag je nieuwe krabbels alleen nog
   * via de open lijn. Zie startGalleryPoll in logic/gallery.js.
   */
  paalInBeeld() { return !this.state.isMobile || !this.tekentNu(); },

  /**
   * Hoe breed het tekenvenster is: het hele scherm.
   *
   * Het was een zwevend venster van STUDIO_W bij STUDIO_H, met een knop om hem groot
   * te maken. Tekenen doe je niet naast iets anders, dus nu vult hij altijd alles
   * boven de taakbalk en is er geen tweede stand meer (8 oktober 2026).
   *
   * Twee plekken hebben dit getal nodig en die moeten hetzelfde antwoord krijgen:
   * de stijl van het venster (zie studioVenster in logic/render-vals.js) en de som
   * die uitrekent hoe groot het doek wordt (computeCanvasSize in logic/lifecycle.js).
   */
  studioBreed() { return window.innerWidth; },

  /**
   * En hoe hoog: alles boven de taakbalk, want die blijft staan. Daar staat zijn
   * knop "Tekenen", en de rest van je programma's.
   *
   * Het doek schaalt mee met de schermhoogte. Aan het venster trekken kan niet, en dat
   * is met opzet: dan veranderen de pixels onder je handen van formaat.
   */
  studioHoog() {
      if (this.state.isMobile) return window.innerHeight;
      return window.innerHeight - TASKBAR_H;
    },

  openStudio() {
      if (!this.state.isMobile) this.vensterNaarVoren('studio');
      else this.stopGalleryPoll();
      // Staat het doek al in de pagina, dan eerst vastleggen wat erop staat. Het
      // herstel hieronder zette anders de opname van het laatste wegklappen terug,
      // en dan was alles wat je daarna tekende weg.
      if (this.state.studioOpen) this.snapshotCanvas();
      this.needsRestore = true;
      this.setState({ studioOpen: true, studioMin: false });
    },

  /** Weggeklapt, maar niet dicht: het doek blijft staan en de knop in de balk ook. */
  minStudio() {
      // Eerst bewaren, dan verbergen. Andersom bewaart snapshotCanvas niets meer.
      this.snapshotCanvas();
      this.setState({ studioMin: true }, this.startGalleryPoll);
    },

  /**
   * Helemaal dicht.
   *
   * Anders dan wegklappen: het doek gaat uit de pagina en de knop uit de balk. Wat je
   * had staat nog in de opslag van je browser, dus je verliest je werk niet: openStudio
   * zet het terug als je hem opnieuw opent.
   */
  sluitStudio() {
      this.snapshotCanvas();
      this.setState({ studioOpen: false, studioMin: false }, this.startGalleryPoll);
    },

  goStudio() { return this.openStudio(); },

  // Na het plakken: feestje met een vollopend balkje, dan door naar de paal.
  celebrateGo() {
      clearTimeout(this.celebrateTimer);
      playPop();
      this.setState({ celebrate: null, celebrateReady: false, studioMin: true }, () => {
        this.refreshGallery();
        this.startGalleryPoll();
        this.clearLikeBadge();
      });
    },

  goGallery() {
      this.snapshotCanvas();
      // Al op de paal? Dan is de knop de verversknop.
      if (!this.tekentNu()) { this.pullRefresh(); return; }
      this.setState({ studioMin: true }, () => {
        if (this.state.connected && !this.state.galleryItems.length) this.refreshGallery();
        this.startGalleryPoll();
        this.clearLikeBadge();
      });
    }
};
